import { useTranslation } from 'react-i18next';
import { InlineAnchor, Typography } from '@figure/frontlib-gui';
import ReviewAppBase from '../components/ReviewAppBase';

const DelinquencyReviewContainer = () => {
  const { t } = useTranslation();

  return (
    <ReviewAppBase>
      <Typography.Body>
        Our system has indicated you are currently delinquent on a loan. Please post payment to make
        this loan current to progress with your application. If you have further questions, please
        contact us at:{' '}
        <InlineAnchor href={`tel:+${t('phone.unformatted')}`}>{t('phone.formatted')}</InlineAnchor>{' '}
        (6am - 6pm PT, Mon - Sun)
      </Typography.Body>
    </ReviewAppBase>
  );
};

export default DelinquencyReviewContainer;
